import React from "react";
import PropTypes from 'prop-types';

export default class Button extends React.PureComponent {
    renderLoader = () => {
        let { isLoading } = this.props;

        if (!isLoading) {
            return false;
        }

        return <span>&#59448;</span>;
    };

    clickHandler = () => {
        let { onClick, isDisabled } = this.props;

        if (isDisabled) {
            return false;
        }

        if (typeof onClick === 'function') {
            return onClick();
        }
    };

    render() {
        let { value, isLoading, className, children, isDisabled } = this.props;

        return (
            <button type={'submit'} className={'button ' + (isLoading ? ' loading' : '') + (isDisabled ? ' disabled' : '') + (className ? ` ${className}` : '')} name={'submit'} onClick={this.clickHandler}>
                {isLoading ? '' : (value ? value : children)}{this.renderLoader()}
            </button>
        );
    }
}

Button.propTypes = {
    children: PropTypes.node,
    value: PropTypes.string,
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func
};
